import { MuiAlert, Typography, strIsNullOrEmpty } from '@fox/atoms';
import { Flex } from '@fox/layout';
import * as moment from 'moment';
import styled, { useTheme } from 'styled-components';
import { useComponentStyleContext } from '../../component-style-context';
import { SwiftFoxEvent } from '../events/contracts';
import { RsvpButton } from '../events/rsvp-button';
import { useEventListContext } from './event-list-context';
import { getEventType } from './util';

const EventItemWrapper = styled.div`
	display: flex;
	padding: 1rem;
	justify-content: space-between;
	border-radius: 10px;
	border: 1px solid ${props => props.theme.palette.grey[300]};
	transition: transform 0.2s ease-in-out;
	cursor: pointer;
	@media (min-width: 800px) {
		&:hover {
			transform: scale(1.01);
			background-color: ${props => props.theme.palette.grey[50]};
		}
	}
	@media (max-width: 600px) {
		flex-direction: column;
		gap: 1rem;
	}
`;
export function ListEventItem({ event }: { event: SwiftFoxEvent }) {
	const { rsvpOptions, refetch } = useEventListContext();
	const startDate = event.eventStart ? moment(event.eventStart).format('h.mm a, DD MMM YYYY') : '';
	const { headerFont, headerFontColour, font } = useComponentStyleContext();
	const type = getEventType(event);
	const theme = useTheme();
	return (
		<EventItemWrapper>
			<div>
				<Typography
					variant="h4"
					style={{
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						fontSize: '1.3rem',
						fontWeight: 'bold',
						...headerFont,
						...headerFontColour
					}}
				>
					{event.name}
				</Typography>
				<Typography
					style={{
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						fontSize: '0.8rem',
						...font
					}}
				>
					<span style={{ color: theme.colors.primary, fontWeight: 'bold' }}>{type}</span>
					{startDate ? <span> | {startDate}</span> : null}
					{event.location?.formatted ? <span> | {event.location.formatted}</span> : null}
				</Typography>
			</div>
			<Flex>
				{!strIsNullOrEmpty(event?.rsvpStatus) ? (
					<MuiAlert severity="success" sx={{ backgroundColor: 'transparent' }}>
						{rsvpOptions?.find(option => option.id === event?.rsvpStatus)?.displayName}
					</MuiAlert>
				) : null}
				<RsvpButton
					eventStart={event.eventStart}
					isMobile={false}
					eventId={event.id}
					refetch={refetch}
					rsvpFormLink={event.rsvpFormLink}
					availableTickets={event.availableTickets}
				/>
			</Flex>
		</EventItemWrapper>
	);
}
